import { Component } from '@angular/core';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-order-summary-settings',
  templateUrl: './order-summary-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpOrderSummarySettingsComponent extends OmpSectionSettings {}
